import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=ecbbe544"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports